import { createAction } from 'redux-starter-kit';

export const SET_QESTIONNARES = 'questionnares/SET';
export const SET_ANSWERS = 'questionnares/SET_ANSWERS';
export const SET_CUSTOMERS_RESPONSES = 'questionnares/GET_RESPONSES';
export const SET_IS_JOINED_CUSTOMER = 'questionnares/SET_IS_JOINED';

const setQuestionnares = createAction(SET_QESTIONNARES);
const setAnswers = createAction(SET_ANSWERS);
const setCustomersResponses = createAction(SET_CUSTOMERS_RESPONSES);
const setIsJoinedCustomer = createAction(SET_IS_JOINED_CUSTOMER);

export const questionnareActions = {
  setQuestionnares,
  setAnswers,
  setCustomersResponses,
  setIsJoinedCustomer
};
